import { GuardianSimple } from '@dreryk/egabinet-patient-frontend-api';

import { Link, ModalWidth, RemoveIcon, ShowModalEventInterceptor, Tooltip } from '@dreryk/react-components';

import { guardiansTranslationKeys } from '../../../../../../../translations';
import { GuardianMarkAsRemovedParameters } from '../../GuardiansTable.hooks';

type GuardianDeleteIconProps = {
   readonly guardian: GuardianSimple;
   readonly onDelete: (variables: GuardianMarkAsRemovedParameters) => void;
};

export const GuardianDeleteIcon = (props: GuardianDeleteIconProps): JSX.Element => {
   if (props.guardian.sharingPeselWithPatient) {
      return (
         <Tooltip testId={'deleteGuardian'} content={guardiansTranslationKeys.identifyingGuardian}>
            <Link disabled icon={<RemoveIcon />} testId={'removeDisabled'} />
         </Tooltip>
      );
   }

   return (
      <ShowModalEventInterceptor
         testId={'removeGuardian'}
         shouldShowModal
         title={guardiansTranslationKeys.removeGuardian}
         content={guardiansTranslationKeys.doYouWantToRemoveGuardian}
         confirmationButtonLabel={guardiansTranslationKeys.remove}
         modalWidth={ModalWidth.NORMAL}
      >
         <Link
            onClick={() =>
               props.onDelete({
                  guardianId: props.guardian.id,
                  fullName: `${props.guardian.firstName} ${props.guardian.lastName}`,
               })
            }
            icon={<RemoveIcon />}
            testId={'remove'}
         />
      </ShowModalEventInterceptor>
   );
};
